import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { LeftActiveAdminPageEnum, RoutesAdmin } from "../enums";

export const useLeftbarAdminActivePaths = () => {
  const location = useLocation();
  const leftAdminActivePage = useMemo((): LeftActiveAdminPageEnum => {
    switch (true) {
      case location.pathname.includes(RoutesAdmin.COMPANIES):
        return LeftActiveAdminPageEnum.Companies;
      case location.pathname.includes(RoutesAdmin.AUDIT_LOGS):
        return LeftActiveAdminPageEnum.AuditLogs;
      case location.pathname.includes(RoutesAdmin.PROVIDER_LOGS):
        return LeftActiveAdminPageEnum.ProviderLogs;
      case location.pathname.includes(RoutesAdmin.ETL_JOB_LOGS):
        return LeftActiveAdminPageEnum.EtlJobLogs;
      case location.pathname.includes(RoutesAdmin.PROCESSES):
        return LeftActiveAdminPageEnum.Processes;
      case location.pathname.includes(RoutesAdmin.MESSAGING_LOGS):
        return LeftActiveAdminPageEnum.MessagingLogs;
      case location.pathname.includes(RoutesAdmin.REPORT_MANAGEMENT):
        return LeftActiveAdminPageEnum.ReportManagement;
      case location.pathname.includes(RoutesAdmin.TOOLS):
        return LeftActiveAdminPageEnum.Tools;
      case location.pathname.includes(RoutesAdmin.BACKUP_MANAGEMENT):
        return LeftActiveAdminPageEnum.BackupManagement;
      case location.pathname.includes(RoutesAdmin.MAP_CACHE_STAT):
        return LeftActiveAdminPageEnum.MapCacheStat;
      case location.pathname.includes(RoutesAdmin.SUPPLIER_QUARANTINES):
        return LeftActiveAdminPageEnum.SupplierQuarantines;
      case location.pathname.includes(RoutesAdmin.AI_CONVERSATION_STATS):
        return LeftActiveAdminPageEnum.AiConversationStats;
      case location.pathname.includes(RoutesAdmin.AI_CONVERSATIONS):
        return LeftActiveAdminPageEnum.AiConversations;
      default:
        return LeftActiveAdminPageEnum.Settings;
    }
  }, [location.pathname]);

  const isActive = (page: LeftActiveAdminPageEnum) =>
    page === leftAdminActivePage;

  return { leftAdminActivePage, isActive };
};
